export default "__VITE_ASSET__Dik3838h__"